export default "__VITE_ASSET__BOQMaU_H__"